import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
export function template() {
  const image = this.helpers.CAROUSEL_IMAGES[this.state.step];
  return /* @__PURE__ */ jsx("div", { sel: ".event-carousel", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(ButtonEl, { sel: ".event-button", attrs: {
    theme: ButtonTheme.Tertiary,
    icon: "arrow-left"
  }, on: {
    click: this.helpers.previousStep
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx("div", { sel: ".event-image" }, /* @__PURE__ */ jsx("img", { sel: ".event-image", attrs: {
    src: image
  } })), /* @__PURE__ */ jsx(ButtonEl, { sel: ".event-button", attrs: {
    theme: ButtonTheme.Tertiary,
    icon: "arrow-right"
  }, on: {
    click: this.helpers.nextStep
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }));
}
